import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'relative',
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    overflow: 'hidden',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1,
    color: theme.palette.common.white,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },
  image: {
    display: 'block',
    width: '100%',
    height: 'auto',
    maxHeight: '90vh',
    objectFit: 'contain',
    cursor: 'zoom-out',
  },
}));

interface IImageZoomDialogProps {
  open: boolean;
  onClose: () => void;
  src: string;
  alt: string;
}

export const ImageZoomDialog: React.FC<IImageZoomDialogProps> = ({ open, onClose, src, alt }) => {
  const classes = useStyles();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth classes={{ paper: classes.paper }}>
      <IconButton aria-label="Close enlarged image" className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </IconButton>
      <img src={src} alt={alt} className={classes.image} onClick={onClose} />
    </Dialog>
  );
};
